import React from 'react';
import { Tabs } from 'components/Display';

type Props = {
  docId?: string,
  index: number,
}

const BrandTabs = ({ docId, index = 0 }: Props) => {
  return <>
    {!!docId && (
      <Tabs
        tabs={[
          {
            label: 'Edit',
            to: `/brands/edit/${docId}`
          },
          {
            label: 'Revisions',
            to: `/brands/edit/${docId}/revisions`
          }
        ]}
        value={index}
      />
    )}
  </>
}

export default BrandTabs;
